<template>
  <div :class="$style.container">
    <template v-if="!isExternalCheckoutProvider">
      <div :class="$style.row">
        <div :class="$style.box">
          <p
            :class="$style.label"
            v-text="$t('amount.for.refund')"
          ></p>
          <p
            :class="$style.text"
            v-text="displayAmount"
          ></p>
        </div>
        <div :class="$style.box">
          <p
            :class="$style.label"
            v-text="getCommissionText"
          ></p>
          <p
            :class="$style.text"
            v-text="displayCommission"
          ></p>
        </div>
      </div>
    </template>

    <template v-if="hasEnoughAmount">
      <div :class="$style.box">
        <p
          :class="$style.label"
          v-text="$t('debited.from.balance')"
        ></p>
        <p
          :class="{ [$style.text]: true, [$style.large]: true }"
          v-text="displayTotal"
        ></p>
      </div>
    </template>
    <template v-else>
      <div :class="$style.box">
        <p
          v-html="$t('not.enough.funds.for.refund', {
            displayAmount: displayDifference
          })"
        ></p>
      </div>
    </template>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

import { formatAmount } from 'lib/utils/amount';

export default {
  name: 'RefundCommission',
  props: {
    large: Boolean,
  },
  computed: {
    currency() {
      return this.data.currency;
    },
    balance() {
      if (!this.getCurrentProject.balance) {
        return 0;
      }

      return this.getCurrentProject.balance;
    },
    hasEnoughAmount() {
      return this.balance >= this.getTotalAmount;
    },
    getTotalAmount() {
      if (!this.data.commission) {
        return 0;
      }

      return this.data.amount + this.data.commission;
    },
    displayAmount() {
      return formatAmount(this.data.amount, this.currency);
    },
    displayCommission() {
      return formatAmount(this.data.commission, this.currency);
    },
    displayTotal() {
      return formatAmount(this.data.total, this.currency);
    },
    displayDifference() {
      if (this.hasEnoughAmount) {
        return 0;
      }

      return formatAmount(Math.abs(this.balance - this.getTotalAmount), this.currency);
    },
    getCommissionText() {
      switch (this.data.commissionPercent) {
        case 5:
          return `${this.$t('common.commission')} — 5% / ${this.$t('common.rf')}`;
        case 6:
          return `${this.$t('common.commission')} — 6% / ${this.$t('common.cis')}`;
        case 8:
          return `${this.$t('common.commission')} — 8% / ${this.$t('common.ukraine')}`;
        default:
          return this.$t('common.commission');
      }
    },
    ...mapState('refund', ['data']),
    ...mapGetters(['getCurrentProject', 'isExternalCheckoutProvider']),
  },
};
</script>

<style lang="sass" module>
  .container
    position: relative

  .row
    display: grid
    grid-template-columns: 1fr 1fr
    grid-gap: 20px

    &:not(:last-child)
      margin-bottom: 20px

  .box
    font-weight: 500
    font-size: 14px
    line-height: 18px
    color: #fff

  .label
    margin: 0 0 10px
    font-weight: 400
    font-size: 14px
    line-height: 18px
    color: #fff
    opacity: .75

  .text
    font-weight: 600
    font-size: 20px
    line-height: 24px
    color: #fff

    &.large
      font-size: 36px
      line-height: 44px
</style>
